module.exports = __webpack_public_path__ + "static/media/incikelogo.cff19a1b.jpg";